/* Maison Fianchetto (19/10, refonte téléphone).
   v2 (retour cliente : « le défilement des carrousels fait des à-coups ») : le glissement piloté par script est retiré ;
   les carrousels utilisent le défilement natif du téléphone, avec une carte calée au centre (voir assets/mf-refonte.css,
   « CARROUSELS, v2 »). Il ne reste ici que le bouton des cookies. */
/* 19/10 (retour cliente : « Modifier mes choix de cookies ne m'emmène nulle part ») : bouton de la page Gestion des cookies.
   Ouvre le panneau des cookies de Shopify ; si le panneau ne s'ouvre pas (bandeau désactivé, aperçu), un message
   explique quoi faire au lieu de ne rien afficher. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[onclick*="privacyBanner"], [data-mf-cookies]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var note = b.parentNode.querySelector('.mf-cookies-note');
    function fallback() {
      if (document.querySelector('[id^="shopify-pc"]')) return;
      if (!note) {
        note = document.createElement('span');
        note.className = 'mf-cookies-note';
        note.setAttribute('role', 'status');
        note.textContent = 'Le réglage des cookies s’ouvre depuis le bandeau affiché à votre première visite. ' +
          'Pour le faire réapparaître, supprimez les cookies de ce site dans les réglages de votre navigateur.';
        b.insertAdjacentElement('afterend', note);
      }
    }
    try {
      if (window.privacyBanner && window.privacyBanner.showPreferences) {
        var p = window.privacyBanner.showPreferences();
        if (p && p.then) p.then(function () { setTimeout(fallback, 900); }, fallback);
        else setTimeout(fallback, 900);
      } else {
        fallback();
      }
    } catch (err) {
      fallback();
    }
  }, true);
})();
